import React from "react";
import OrdersPage from "./OrdersPage";
import V2RouteShell from "../V2RouteShell";

function OrdersV2(props) {
  return (
    <V2RouteShell>
      <OrdersPage {...props} />
    </V2RouteShell>
  );
}

export default OrdersV2;
